<template>
    <div class="content">
        <div class="search_wrapper">
            <div class="search_head">
                <span>查询条件</span>
                <i class="searchDomw" @click="isSearchContent = !isSearchContent" :class="isSearchContent == true ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
                <!-- <el-button
                    style="float: right; padding: 3px 0; color: #000"
                    type="text"
                    @click="clearData"
                >
                    <i class="el-icon-refresh"></i>
                    刷新页面
                </el-button> -->
            </div>
            <div class="search_content" v-show="isSearchContent">
                <div class="search_inline">
                    <el-form label-width="90px">
                        <el-row>
                            <el-col :span="5">
                                <el-form-item label="姓名">
                                    <el-input
                                        v-model="customerName"
                                        placeholder="姓名"
                                    ></el-input>
                                </el-form-item>
                            </el-col>

                            <el-col :span="5" :offset="1">
                                <el-form-item label="取餐方式">
                                    <el-select
                                        v-model="takeWay"
                                        placeholder="请选择取餐方式"
                                        style="width: 100%"
                                    >
                                        <el-option
                                            v-for="item in takeList"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="5" :offset="2">
                                <el-button
                                    type="primary"
                                    icon="el-icon-search"
                                    @click="searchData"
                                    class="searchBtns"
                                    >搜索</el-button
                                >
                                <el-button
                                    type="info"
                                    icon="el-icon-delete"
                                    @click="clearData"
                                    >清除条件</el-button
                                >
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
                <!-- <div class="arrowDown">
                    <i
                        :class="
                            isSearchContent === true
                                ? 'el-icon-arrow-up'
                                : 'el-icon-arrow-down'
                        "
                        style="color: #000"
                        @click="isSearchContent = !isSearchContent"
                    ></i>
                </div> -->
            </div>
        </div>
        <div class="table_title">
            <!-- 筛选按钮 -->
            <div class="screen_container">
                <el-button-group>
                    <el-button
                        type="primary"
                        icon="el-icon-refresh"
                        class="dropRests"
                        @click="clearData"
                    ></el-button>
                    <!-- <el-button type="primary" style="padding: 10px 20px"> -->
                        <el-dropdown trigger="click" :hide-on-click="false" class="dropdown1">
                            <span class="el-dropdown-link">
                                <i
                                    class="el-icon-s-grid el-icon--right"
                                    style="color: #fff"
                                ></i>
                                <i
                                    class="el-icon-arrow-down el-icon--right"
                                ></i>
                            </span>
                            <el-dropdown-menu
                                slot="dropdown"
                                class="table_checkbox"
                            >
                                <el-dropdown-item>
                                    <el-checkbox-group
                                        v-model="tableChekbox"
                                        @change="tableChekboxChange"
                                    >
                                        <el-checkbox label="序号"></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="订单号"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox label="姓名"></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="取餐方式"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="支付方式"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox label="状态"></el-checkbox
                                        ><br />
                                        <el-checkbox label="操作"></el-checkbox
                                        ><br />
                                    </el-checkbox-group>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    <!-- </el-button> -->
                </el-button-group>
            </div>
        </div>
        <!-- tableb表格 -->
        <div class="table_container">
            <el-table
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                :header-cell-style="{ background: '#e6e6e6', color: '#000' }"
                border
            >
                <el-table-column
                    label="序号"
                    align="center"
                    width="80"
                    type="index"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '序号'
                        ) != -1
                    "
                >
                    <template scope="scope">
                        <span
                            >{{
                                scope.$index +
                                (pageOne.pageNo - 1) * pageOne.pageSize +
                                1
                            }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="订单号"
                    prop="orderNumber"
                    align="center"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '订单号'
                        ) != -1
                    "
                ></el-table-column>
                <el-table-column
                    label="姓名"
                    prop="customerName"
                    align="center"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '姓名'
                        ) != -1
                    "
                ></el-table-column>
                <el-table-column
                    label="取餐方式"
                    align="center"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '取餐方式'
                        ) != -1
                    "
                >
                    <template scope="scope">
                        <span v-if="scope.row.takeWay == 0">送餐</span>
                        <span v-if="scope.row.takeWay == 1">堂食</span>
                        <span v-if="scope.row.takeWay == 2">自取</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="支付方式"
                    align="center"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '支付方式'
                        ) != -1
                    "
                ></el-table-column>
                <el-table-column
                    label="状态"
                    align="center"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '状态'
                        ) != -1
                    "
                >
                    <template scope="scope">
                        <span v-if="scope.row.payStatus == 1">已支付</span>
                        <span v-if="scope.row.payStatus == 0">已支付</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="操作"
                    align="center"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '操作'
                        ) != -1
                    "
                >
                    <template scope="scope">
                        <el-button
                            type="text"
                            size="mini"
                            @click="showDetail(scope)"
                            >查看</el-button
                        >
                        <el-button
                            type="text"
                            size="mini"
                            @click="remind(scope)"
                            v-if="scope.row.takeWay == 0"
                            >提醒</el-button
                        >
                        <el-button
                            type="text"
                            size="mini"
                            v-if="scope.row.takeWay == 0"
                            @click="assignAction(scope)"
                            >指派</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination_container">
            <el-pagination
                :page-size="pageOne.pageSize"
                :current-page.sync="pageOne.pageNo"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pageOne.total"
                @size-change="handletableDataSize"
                @current-change="handleTableDataChange"
            ></el-pagination>
        </div>
        <person-info v-if="sendVisible" :openData="sendInfo"></person-info>
        <!-- <send-info
      v-if="personVisible"
      :openData="personInfo"
    ></send-info> -->
        <show-details :show="showDetailState" :datas="detailDatas">
        </show-details>

        <el-dialog title="指派" :visible="assignState" @close="cancelAssign">
            <el-form ref="form" :model="assignForm" label-width="100px">
                <el-form-item label="姓名：">
                    <el-input
                        v-model="assignForm.customerName"
                        disabled
                    ></el-input>
                </el-form-item>
                <el-form-item label="餐饮类型：">
                    <el-checkbox-group v-model="assignForm.orderType">
                        <el-checkbox label="1" disabled>早餐</el-checkbox>
                        <el-checkbox label="2" disabled>中餐</el-checkbox>
                        <el-checkbox label="3" disabled>晚餐</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item label="取餐方式：">
                    <el-checkbox-group v-model="assignForm.takeWay">
                        <el-checkbox label="0" disabled>送餐</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item label="部门：" prop="departmentId">
                    <el-select
                        v-model="assignForm.departmentId"
                        placeholder="请选择"
                        size="mini"
                        style="width: 100%"
                        @change="selectDepart"
                    >
                        <el-option
                            v-for="item in subsidyLevelOptions"
                            :key="item.value"
                            :label="item.departmentName"
                            :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="送餐人员：" prop="personId">
                    <el-select
                        v-model="assignForm.personId"
                        placeholder="请选择"
                        size="mini"
                        style="width: 100%"
                    >
                        <el-option
                            v-for="item in personIdOptions"
                            :key="item.value"
                            :label="item.personName"
                            :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelAssign">取 消</el-button>
                <el-button type="primary" @click="saveAssign">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import request from "@/utils/request.js"
import personInfo from "./components/personInfo"
import sendInfo from "./components/sendInfo"
import { getItemDetail, getData, setRemind, setAssign } from "./api/index"
import showDetails from "./components/showDetails.vue"
export default {
    props: ["personData"],
    components: { personInfo, sendInfo, "show-details": showDetails },
    data() {
        return {
            takeList: [
                { value: "0", label: "送餐" },
                { value: "1", label: "堂食" },
                { value: "2", label: "自取" },
            ],
            subsidyLevelOptions: [],
            personIdOptions: [],
            assignForm: {
                name: "",
                orderType: [],
                takeWay: [],
                personName: "",
                departmentId: "",
            },
            assignState: false,
            detailDatas: {},
            showDetailState: false,
            sendVisible: false,
            sendInfo: {},
            personVisible: false,
            personInfo: {},
            customerName: "",

            takeWay: "",
            isSearchContent: false,
            pageOne: { pageSize: 10, pageNo: 1, total: 0 },
            tableData: [],
            dialogVisible: false, //人员编辑
            dialogInfo: {},
            personState: false, //新增人员
            personInfo: {},
            radioId: "",
            tempTableChekbox: [
                "序号",
                "订单号",
                "姓名",
                "取餐方式",
                "支付方式",
                "状态",
                "操作",
            ],
            tableChekbox: [
                "序号",
                "订单号",
                "姓名",
                "取餐方式",
                "支付方式",
                "状态",
                "操作",
            ],
        }
    },
    created() {
        // this.getList()
        this.getList()
        //  this.departmentlist()
    },
    watch: {
        personData(old, news) {
            // console.log(old, news, this.personData, "组织id");
            this.getList()
        },
    },
    methods: {
        cancelAssign() {
            this.assignState = false
        },
        saveAssign() {
            let { orderType, takeWay } = this.assignForm

            setAssign({
                ...this.assignForm,
                orderType: orderType.join,
                takeWay: takeWay.join(),
            }).then(({ code }) => {
                if (code == 200) {
                    this.$message({
                        type: "success",
                        message: "指派成功!",
                    })
                    this.assignState = false
                    this.assignForm = {}
                } else {
                    this.$message({
                        type: "success",
                        message: "指派失败!",
                    })
                }
            })
        },
        async departmentlist() {
            let params = {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                webfrom: "1",
                qujiId: JSON.parse(localStorage.getItem("czUserInfo")).qujiId,
                shengjiId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .shengjiId,
                shijiId: JSON.parse(localStorage.getItem("czUserInfo")).shijiId,
                stationId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .stationId,
                shequjiId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .shequjiId,
            }
            params = Object.assign({}, params)
            await request({
                url: "/ypt/admin/department/info/findList",
                method: "POST",
                data: params,
            }).then((res) => {
                // console.log(res);
                this.subsidyLevelOptions = res.content.list
            })
        },
        selectDepart(val) {
            let params = {
                departmentId: val,
                webfrom: "1",
                qujiId: JSON.parse(localStorage.getItem("czUserInfo")).qujiId,
                shengjiId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .shengjiId,
                shijiId: JSON.parse(localStorage.getItem("czUserInfo")).shijiId,
                stationId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .stationId,
                shequjiId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .shequjiId,
            }
            params = Object.assign({}, params)
            request({
                url: "/sqyl/admin/person/info/findPersonByDept",
                method: "POST",
                data: params,
            }).then((res) => {
                this.personIdOptions = res.content
                this.assignForm.personId = ""
            })
        },
        detailClose() {
            this.showDetailState = false
        },
        // 指派
        assignAction({ row }) {
            let {
                customerName,
                takeWay,
                orderType,
                personId,
                departmentId,
            } = row
            this.selectDepart(departmentId)
            this.assignState = true

            this.assignForm = {
                customerName,
                takeWay: takeWay.split(""),
                orderType: orderType.split(""),
                personId,
                departmentId,
            }
            console.log("-----------------")
            console.log(this.assignForm)

            // let e = this.assignForm
        },
        remind({ row: { id, customerId, personId } }) {
            this.$confirm("是否通知送餐人员马上送餐", "提醒", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    setRemind({ orderId: id, customerId, personId }).then(
                        ({ code }) => {
                            if (code == 200) {
                                this.$message({
                                    type: "success",
                                    message: "提醒成功",
                                })
                            }
                        }
                    )
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "提醒失败",
                    })
                })
        },
        // 查看
        showDetail({ row }) {
            this.showDetailState = true
            this.detailDatas = { ...row }
        },

        // 搜索
        searchData() {
            this.pageOne.pageNo = 1
            this.getList()
        },
        // 关闭人员信息弹窗
        cancleOpen() {
            this.dialogInfo = {}
            this.dialogVisible = false
            // this.tableData = [];
            this.getList()
        },
        //删除表格信息
        deleteItem(date) {
            let params = {
                communityWorkerId: date.id,
                socialOrgId: this.personData,
            }
            this.$confirm("确认永久删除吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                this.$http
                    .request({
                        url:
                            "/ypt/admin/communityWorker/info/deleteBySocialOrg",
                        method: "POST",
                        data: params,
                    })
                    .then((res) => {
                        if (res.code === 200) {
                            this.$message.success("删除成功")
                            // this.tableData = [];
                            this.getList()
                        }
                    })
            })
        },
        // 当前页
        handleTableDataChange(val) {
            this.pageOne.pageNo = val
            this.getList()
        },
        // 分页大小
        handletableDataSize(val) {
            this.pageOne.pageSize = val
            this.getList()
        },
        // 选择列的展示方式
        tableChekboxChange(val) {
            this.tempTableChekbox = val.map((item) => item)
        },
        //重置
        clearData() {
            this.customerName = ""
            this.customerName = ""
            this.pageOne.pageSize = 10
            this.pageOne.pageNo = 1
            this.getList()
        },
        // 获取数据
        getList() {
            let { customerName, takeWay } = this
            let params = {
                pageNo: this.pageOne.pageNo,
                pageSize: this.pageOne.pageSize,
                socialOrgId: this.personData,
                customerName,
                takeWay,
                communityId: this.personData,
            }
            getData(params).then(({ content }) => {
                if (content) {
                    let { list, count } = content
                    this.tableData = list
                    this.pageOne.total = count
                }
            })
        },
    },
}
</script>
<style lang="less" scoped>
/deep/.btn_group {
    margin-top: 0px !important;
}
/deep/.table_title {
    margin-top: 10px !important;
}

/deep/ .search_wrapper {
  display: flex;
  flex-direction: column;
  position: relative;
  background: #F1F2F6;
  box-shadow:  0 0 6px rgba(151, 151, 151, .16);
  overflow: hidden;
  border-radius: 4px;
  .search_head {
    background: #fff;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    color: rgb(0, 0, 0);
    border-color: rgb(217, 217, 217);
    padding: 6px 15px;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
  }
  .search_content {
    padding: 15px 20px 0px 5px;
    border: 1px solid rgb(217, 217, 217);
    // display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  .search_inline {
    width: 100%;
  }
  .arrowDown {
    width: 28px;
    height: 28px;
    background: #edf2f0;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 50%;
    bottom: -14px;
    transform: translate(-50%, 0px);
    border-radius: 50%;
    z-index: 2;
    cursor: pointer;
  }
}
.searchDomw{cursor: pointer;}
</style>